import DPDropDown from "framework/components/DPDropDown";
import DPTextBox from "framework/components/DPTextBox";
import { Text } from "framework/validators/TextValidation";
import { Col, Label, Row } from "reactstrap";
import imageExcelDownload from "../../../assets/images/Download.png"
import ExcelTemplate1 from "../../../assets/File/ExcelTemplate1.xlsx";
import ExcelTemplate2 from "../../../assets/File/ExcelTemplate2.xlsx";


export const CustomStockFreezeContent = ({
    formData,
    setFormData,
    fromLocations,
    txnTypes,
    fileInputRef1,
    fileInputRef2
}) => {
    return (
        <>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Select Txn Type"
                        textType="text"
                        optionGroup={txnTypes}
                        selectedGroup={formData.selectedTxn}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                selectedTxn: e["value"]
                            });
                        }}
                        disabled={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPDropDown
                        rowClass="mb-4-sm"
                        labelText="Select Location"
                        textType="text"
                        optionGroup={fromLocations}
                        selectedGroup={formData.selectedLocation}
                        onChange={(e) => {
                            setFormData({
                                ...formData,
                                selectedLocation: e["value"]
                            });
                        }}
                        disabled={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Ref Doc Number"
                        textType="text"
                        value={formData.refDocNumber}
                        onChange={(e) => {

                            const valCode = Text(
                                e.target,
                                30,
                                true,
                                false,
                                "upper",
                                false
                            )

                            setFormData({
                                ...formData,
                                refDocNumber: valCode,
                            });
                        }}
                        disabled={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Remarks"
                        textType="text"
                        value={formData.remark1}
                        onChange={(e) => {

                            const valCode = Text(
                                e.target,
                                50,
                                true,
                                false,
                                "any",
                                true
                            )

                            setFormData({
                                ...formData,
                                remark1: valCode,
                            });
                        }}
                        disabled={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Label htmlFor="example-text-input" className="col-md-4 col-form-label-sm">
                        Stock Count Excel File
                    </Label>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={(e) => setFormData({ ...formData, excelFile1: e.target.files[0] })}
                        ref={fileInputRef1}
                    />
                </Col>
                <Col sm={12} md={6}>
                    <li className="import-export-button" style={{ display: "block" }}>
                        <a
                            href={ExcelTemplate1}
                            download="Stock Count Excel File"
                            data-tip
                            title="Stock Count Excel File"
                        >
                            <img
                                className="manImg"
                                src={imageExcelDownload}
                                style={{ width: "40px", height: "40px" }}
                                alt="Download Stock Count Excel File"
                            />
                        </a>
                    </li>
                </Col>
            </Row>

            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Label htmlFor="example-text-input" className="col-md-4 col-form-label-sm">
                        Bin Excel File
                    </Label>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={(e) => setFormData({ ...formData, excelFile2: e.target.files[0] })}
                        ref={fileInputRef2}
                    />
                </Col>
                <Col sm={12} md={6}>
                    <li className="import-export-button" style={{ display: "block" }}>
                        <a href={ExcelTemplate2} download="Bin Excel File" data-tip title="Bin Excel File">
                            <img
                                className="manImg"
                                src={imageExcelDownload}
                                style={{ width: "40px", height: "40px" }}
                                alt="Download Bin Excel File"
                            />
                        </a>
                    </li>
                </Col>
            </Row>

        </>
    );
};